module.exports = "uniform sampler2D positionTex;\nuniform sampler2D velocityTex;\nuniform vec2 resolution;\nuniform float size;\n\nattribute vec2 idx;\n\nvarying float factor;\n\nvoid main()\n{\n\tvec4 pos = texture2D(positionTex, idx);\n\tvec4 vel = texture2D(velocityTex, idx);\n\n\tfactor = 1.0f - pos.w / vel.y;\n\tvec4 mvPosition = modelViewMatrix * vec4(pos.xyz, 1.0);\n\tgl_PointSize = sin(factor * 3.14) * 1.25f;\n\tgl_Position = projectionMatrix * mvPosition;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/curlNoiseRender.vs
// module id = 7
// module chunks = 0